module.exports = __webpack_public_path__ + "img/1080_17.519921e9.jpg";